import React from "react";
import { Navigate } from "react-router-dom";
import { AuthUser } from "../types";

// Client-side convenience only - the backend's require_role is the real
// enforcement (returns 403). This just avoids a "page loads then every
// fetch 403s" experience for a non-admin who navigates here directly.
export default function RequireRole({
  user,
  role,
  children
}: {
  user: AuthUser;
  role: string;
  children: React.ReactNode;
}) {
  if (!user.roles?.includes(role)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
